import BaseModel from "./BaseModel";
import {getDocs, limit, orderBy, query, where, startAt} from "firebase/firestore";

export default class ShopifySite extends BaseModel {
    static data_name = 'shopify_sites';


    static async instanceFromPotentialShopifySite(potential_shopify_site){
        let instance = new this();
        instance.document_id = potential_shopify_site.handle;
        instance.potential_shopify_site_document_id = potential_shopify_site.document_id;
        instance.name = potential_shopify_site.name;
        instance.handle = potential_shopify_site.handle;
        instance.shopify_id = potential_shopify_site.shopify_id;
        instance.api_url = potential_shopify_site.api_url;
        instance.domain = potential_shopify_site.shopify_domain;
        instance.myshopify_domain = potential_shopify_site.shopify_myshopify_domain;
        instance.country = potential_shopify_site.shopify_country;
        instance.currency = potential_shopify_site.shopify_currency;
        instance.description = potential_shopify_site.shopify_description;
        instance.ships_to_countries = potential_shopify_site.shopify_ships_to_countries;
        instance.currency_symbol = potential_shopify_site.currency_symbol;
        instance.approved_at = new Date();

        await instance.save();
        return instance;
    }

    get path(){
        return `/sites/${this.handle}`;
    }

    static async getByPotentialShopifySiteId(potential_shopify_site_document_id){
        return this.getBy('potential_shopify_site_document_id', potential_shopify_site_document_id);
    }

}